import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import MyTask from "./myTask/myTask";
import MyTeamTask from "./myTeamTask/myTeamTask";
import UserManagement from "./userManagement/userMangement";
import TagsList from "./tag/tagsList";

const VALID_TABS = ["my-task", "my-team-task", "lead-management", "user-management"];

const TABS = [
  { key: "my-task",         label: "My Task",         icon: "fal fa-briefcase" },
  { key: "my-team-task",    label: "My Team Task",    icon: "fal fa-users" },
  { key: "lead-management", label: "Lead Management", icon: "fal fa-tasks" },
  { key: "user-management", label: "User Management", icon: "fal fa-user-tie" },
];

class LeadManagementMain extends Component {
  setTab = (tab) => {
    this.props.history.push(`/lead-management/${tab}`);
  };

  render() {
    const tabParam = this.props.match && this.props.match.params && this.props.match.params.tab;
    const activeTab = VALID_TABS.includes(tabParam) ? tabParam : "my-task";

    return (
      <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px" }}>
        <Container fluid className="px-0">
          <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>

            {/* Tab nav — identical style to expense/fee module */}
            <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px" }}>
              <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                {TABS.map((tab) => {
                  const isActive = activeTab === tab.key;
                  return (
                    <li className="nav-item" key={tab.key}>
                      <a
                        className={`nav-link ${isActive ? "active" : ""}`}
                        href="#"
                        onClick={(e) => { e.preventDefault(); this.setTab(tab.key); }}
                        style={{
                          cursor: "pointer",
                          fontWeight: 700,
                          fontSize: 14,
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "12px 20px",
                          color: isActive ? "#6366f1" : "#4b5563",
                          background: isActive ? "#fff" : "transparent",
                          borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                          borderWidth: "1.5px",
                          borderBottomWidth: isActive ? "2px" : "1.5px",
                          borderRadius: "10px 10px 0 0",
                          transition: "all 0.15s ease",
                          marginBottom: "-1.5px",
                          textDecoration: "none",
                        }}
                      >
                        <i className={tab.icon} />
                        {tab.label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Content panel */}
            <div style={{ padding: "28px" }}>
              {activeTab === "my-task"         && <MyTask />}
              {activeTab === "my-team-task"    && <MyTeamTask />}
              {activeTab === "lead-management" && <TagsList />}
              {activeTab === "user-management" && <UserManagement />}
            </div>

          </div>
        </Container>
      </div>
    );
  }
}

export default withRouter(LeadManagementMain);
